import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import RestUtilities from '../../services/RestUtilities';
import {
  Grid,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
} from '@mui/material';
import { useSetRecoilState } from 'recoil';
import { loadingState, toastState } from '../../state/RecoilState';
import { FeedbackResponse } from '../../@types/api';

const textAreaProps = { my: 1 };

const CreateTestimonial = () => {
  const { id } = useParams();
  const setToast = useSetRecoilState(toastState);
  const setLoading = useSetRecoilState(loadingState);
  const [feedbackResponse, setFeedbackResponse] = useState<
    FeedbackResponse | undefined
  >(undefined);
  const [useServiceText, setUseServiceText] = useState(false);
  const [useArtistText, setUseArtistText] = useState(false);
  const [suggestReview, setSuggestReview] = useState(false);
  const [frontPageOk, setFrontPageOk] = useState(false);
  const [canProcess, setCanProcess] = useState(true);

  useEffect(() => {
    const getResponse = async () => {
      setLoading(true);
      const res = await RestUtilities.get(`/api/feedback/GetCompleted/${id}`);
      if (res.ok) {
        setFeedbackResponse(res.content as FeedbackResponse);
      }
      setLoading(false);
    };
    if (id) {
      getResponse();
    }
  }, [id, setLoading]);

  const process = async () => {
    const data = {
      feedbackResponse: feedbackResponse,
      useServiceText,
      useArtistText,
      frontPageOk,
      inviteClientToGoogleReview: suggestReview,
      clientName: null,
    };
    var res = await RestUtilities.post('api/feedback/Process', data);
    if (res.ok) {
      setToast('Testimonial Added');
      setCanProcess(false);
    } else {
      setToast('Testimonial Failed');
      setCanProcess(true);
    }
  };

  return (
    <Box>
      {feedbackResponse && (
        <>
          <Typography variant='h5' color='primary'>
            Create Testimonial from Response ID: {id}
          </Typography>
          <Box
            sx={{ mt: 2 }}
            display='flex'
            justifyContent='flex-start'
            alignItems='center'
          >
            <Box sx={{ mr: 3 }}>
              <strong>BookingId: </strong>
              {feedbackResponse.bookingId}
            </Box>
            <Box sx={{ mr: 3 }}>
              <strong>Artist: </strong>
              {feedbackResponse.artistName}
            </Box>
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={feedbackResponse.keepAnon}
                    disabled={true}
                  />
                }
                label='Annonymous, comments will not be used'
              />
            </Box>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              <TextField
                multiline
                id='service-comment'
                label='Comments on MFS'
                value={feedbackResponse.serviceText ?? ''}
                fullWidth
                margin='normal'
                onChange={(e) => {
                  setFeedbackResponse({
                    ...feedbackResponse,
                    serviceText: e.currentTarget.value,
                  });
                }}
                InputProps={{
                  rows: 3,
                  multiline: true,
                  inputComponent: 'textarea',
                }}
                variant='outlined'
                sx={textAreaProps}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={feedbackResponse.keepAnon}
                    checked={useServiceText}
                    onClick={() => setUseServiceText(!useServiceText)}
                  />
                }
                label='Use MFS Testimonial'
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={feedbackResponse.keepAnon}
                    checked={frontPageOk}
                    onClick={() => setFrontPageOk(!frontPageOk)}
                  />
                }
                label='Ok for FrontPage'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                multiline
                id='artist-comment'
                label={`Comments on ${feedbackResponse.artistName}`}
                value={feedbackResponse.artistText ?? ''}
                fullWidth
                margin='normal'
                onChange={(e) => {
                  setFeedbackResponse({
                    ...feedbackResponse,
                    artistText: e.currentTarget.value,
                  });
                }}
                InputProps={{
                  rows: 3,
                  multiline: true,
                  inputComponent: 'textarea',
                }}
                variant='outlined'
                sx={textAreaProps}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={feedbackResponse.keepAnon}
                    checked={useArtistText}
                    onClick={() => setUseArtistText(!useArtistText)}
                  />
                }
                label='Use Artist Testimonial'
              />
            </Grid>
            <Grid item xs={12}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={feedbackResponse.keepAnon}
                      checked={suggestReview}
                      onClick={() => setSuggestReview(!suggestReview)}
                    />
                  }
                  label='Request Google review'
                />
                <Button
                  variant='contained'
                  color='primary'
                  disabled={!canProcess}
                  onClick={process}
                >
                  Process Feedback
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};
export default CreateTestimonial;
